import { Box } from '@mui/material';
import React from 'react';

function MenuItem({ children }) {
  return <Box className="menu-item">{children}</Box>;
}

export default MenuItem;
